import { useMemo } from 'react';

function useStyleProps(params) {
  const { css, style, className, ...restParams } = params;
  return useMemo(
    () => ({
      styleProps: { css, style, className },
      ...restParams
    }),
    [className, css, restParams, style]
  );
}

export { useStyleProps as default };
//# sourceMappingURL=useStyleProps.mjs.map
